module.exports = __webpack_public_path__ + "static/media/Maya USD Plugin (Universal Scene Description).d0a1d503.png";